module.exports = __webpack_public_path__ + "img/img5-2.36c3a578.png";